import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/_services/authentication.service';

@Component({
  selector: 'app-connect-amazon',
  templateUrl: './connect-amazon.component.html',
  styleUrls: ['./connect-amazon.component.scss']
})
export class ConnectAmazonComponent implements OnInit {
  //Amazon
  amazon_callback_uri: string;
  amazon_state: string;
  selling_partner_id: string;

  //User
  current_user: any;
  ff_api_token: string;

  //
  redirect_uri: string;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService
  ) { 

    this.current_user = this.authenticationService.currentUserValue;
    this.ff_api_token = this.current_user.ff_api_token;
    

    //Get Amazon params
    this.amazon_callback_uri = this.route.snapshot.queryParams['amazon_callback_uri'];
    this.amazon_state = this.route.snapshot.queryParams['amazon_state'];
    this.selling_partner_id = this.route.snapshot.queryParams['selling_partner_id'];
    console.log(this.amazon_callback_uri);
    console.log(this.amazon_state);
    console.log(this.selling_partner_id);
    let azrms_url = 'https://azrms.herokuapp.com'; //TODO url conexión con azrms
    //this.redirect_uri = `${azrms_url}/amazon_auths/autenticate?token=${this.ff_api_token}`
    this.redirect_uri = `${azrms_url}/amazon_auths/autenticate`
    
    window.location.replace(`${this.amazon_callback_uri}?redirect_uri=${this.redirect_uri}&amazon_state=${this.amazon_state}&state=${this.ff_api_token}&version=beta`);
    
  }

  ngOnInit() {

  }

}
